<template>
  <myhead @next="next">{{$route.meta.title}}</myhead>
  <div class="center pad40 size18 b000">
    <div v-if="type=='success'">
      <div class="BGon Cfff opacity7 height50px width50px mt50 radius50 auto flex cen size32">
        <van-icon name="success" />
      </div>
      <p class="b500 mt20 mb80">您的考核已通过</p>
    </div>
    <div v-if="type=='fail'">
      <div class="BGred Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32">
        <van-icon name="cross" />
      </div>
      <p class="b500 mt20 mb80">您的考核未通过</p>
    </div>
    <div v-if="type=='waiting'" class="mb80 size15">
      <img src="@/assets/img/icon69.png" class="block width60px auto mb20" alt="">
      注册信息已提交，请等待管理人员审核...
    </div>
    <van-button type="primary" round block @click="next" v-if="type=='success'">下一步</van-button>
    <van-button type="primary" round block @click="next" v-else>返回</van-button>
  </div>
</template>

<script>
export default {
  name: 'Status',
  data () {
    return {
      type: null
    }
  },
  methods: {
    next () {
      if (this.type == 'success') {
        this.$router.push({ path: "/agreement", query: { typeid: 4, title: '注册' } });
      } else {
        // 返回值登录页
        this.$router.push({ path: '/login' });
      }
    },

  },
  created () {
    let { type } = this.$route.query;
    if (type) {
      this.type = type;
    }
  }
}
</script>

<style>
</style>
